export const fontFamily = {
  display: 'Lemur',
  sans: 'Inter',
};
